/**
 * VocabEngineSection — quick stats card row pitching the vocab side.
 */
import { Reveal } from '@/components/Reveal';
import { SectionHeading } from '@/components/SectionHeading';

const STATS = [
  { num: '1000+',   label: '套课程内容' },
  { num: '15万+',   label: '词条覆盖' },
  { num: '70万+',   label: '累计学员' },
  { num: '4500万+', label: '练习完成次数' },
];

export function HomeVocabEngine(): JSX.Element {
  return (
    <section className="relative py-24 md:py-32 border-t border-honey-400/10">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Vocabulary Engine · 单词记忆"
            title={<>把单词变成 <span className="text-gradient-warm">画面</span> 而不是字符</>}
            subtitle="150,000+ 词条 · 艾宾浩斯 SRS · AI 场景配图 · 卡牌式记忆"
          />
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.06}>
              <div className="rounded-3xl border border-honey-400/20 bg-ink-900/40 p-6 text-center">
                <div className="font-score text-4xl text-gradient-honey">{s.num}</div>
                <div className="mt-2 text-xs text-cream-400 font-arcade tracking-widest">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
